import { EventStatus } from "@/lib/shared/enums";

/**
 * Maps an event's flow status to the client-facing dashboard path the client is currently on
 * (e.g. a `deposit` event lands on the deposit page, not the quote dashboard). Single source of
 * truth for "where is this event in the client flow", shared by `getCurrentEventRedirect`
 * and the sourcing tracker's row link.
 * @param eventId - The event's ID
 * @param status - The event's `event_status`
 * @returns The client dashboard path, or null when the status has no dedicated page
 */
export function getClientFlowPath(eventId: number, status: string): string | null {
  switch (status) {
    case EventStatus.CONFIRM_EVENT_DETAILS:
      return `/${eventId}/change-event-details`;
    case EventStatus.DEPOSIT:
      return `/${eventId}/deposit`;
    case EventStatus.CONFIRMED_EVENT_DETAILS:
    case EventStatus.NARROW_OPTIONS:
    case EventStatus.WAIT_FOR_PROPOSALS:
      return `/${eventId}/narrow-options`;
    case EventStatus.QUOTE_DASHBOARD:
      return `/${eventId}/quote-dashboard`;
    case EventStatus.WAIT_FOR_VENUE_CONFIRMATION:
      return `/${eventId}/confirm-book-venue`;
    case EventStatus.VENUE_RECEIPT:
      return `/${eventId}/payment`;
    case EventStatus.CANCELLED:
      return `/${eventId}/quote-dashboard`;
    default:
      return null;
  }
}
